import React, { useState } from "react";
import styles from "../css/login.module.css";
import { MdClose, MdHelpOutline } from "react-icons/md";
import useUsers from "../../../hooks/useUsers";
import { useTranslation } from "react-i18next";

export function FindIdModal({ isOpen, onClose }) {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [showTooltip, setShowTooltip] = useState(false);
  const { t } = useTranslation();

  const { findUsernameByEmail } = useUsers();

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      findUsernameByEmail.mutate(email, {
        onSuccess: async (username) => {
          const formattedUsernames = Array.isArray(username)
            ? username.length > 1
              ? username.join(", ")
              : username[0]
            : username;

          setMessage(formattedUsernames);
        },
        onError: (error) => {
          if (error?.status === 429) {
            setMessage(
              error.message ||
                "요청이 너무 많습니다. 잠시 후 다시 시도해 주세요."
            );
            return;
          }
          setMessage(error.message);
        },
      });
      // TODO: API call to find ID using email
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContainer}>
        <div className={styles.modalHeader}>
          <span>{t("common.login.findId")}</span>
          <MdClose size={24} onClick={onClose} style={{ cursor: "pointer" }} />
        </div>
        <form onSubmit={handleSubmit}>
          <div className={styles.modalContent}>
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>
                {t("common.login.findIdMessage")}
                <span
                  style={{
                    fontSize: "12px",
                    cursor: "pointer",
                    position: "relative",
                    top: "-6px",
                    marginLeft: "4px",
                  }}
                  onClick={() => setShowTooltip(!showTooltip)}
                  title={t("common.login.findIdTooltip")}
                >
                  <MdHelpOutline size={20} color="#008080" />
                  {showTooltip && (
                    <div
                      style={{
                        position: "absolute",
                        bottom: "100%",
                        left: "50%",
                        transform: "translateX(-50%)",
                        backgroundColor: "rgba(0, 0, 0, 0.8)",
                        color: "white",
                        padding: "8px",
                        borderRadius: "4px",
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                        zIndex: 1000,
                      }}
                    >
                      {t("common.login.findIdTooltip")}
                    </div>
                  )}
                </span>
              </label>
              <input
                className={styles.formInput}
                type="email"
                placeholder="example@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            {message && (
              <div
                className={`${styles.message} ${
                  message.includes("@") ? styles.success : styles.error
                }`}
              >
                {message.includes("@") ? (
                  <>
                    {t("common.login.foundId")}
                    <br />
                    {message}
                  </>
                ) : (
                  message
                )}
              </div>
            )}
            <div className={styles.buttonContainer}>
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={onClose}
              >
                {t("common.labels.cancel") || "취소"}
              </button>
              <button type="submit" className="btn btn-sm btn-primary">
                {t("common.login.findId")}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
